module.exports = __webpack_public_path__ + "static/media/ERUPT_2019_pic.0cd8bcbc.jpeg";